<template>
  <div>
    <div class="header-bg">
      <div class="inner_center">
        <h2>全站高质量可下载资源 每日更新</h2>
        <div class="subhead">享有商用授权/不限下载、高速下载、高级搜索等权益</div>
        <i class="icon_vip-txt"/>
      </div>
    </div>
    <div class="members-package">
      <div class="authorization-scoped-wrap">
        <!-- 授权范围 -->
        <div class="authorization-scoped">
          授权范围
        </div>
        <!-- 权益保障 -->
        <div class="rights-and-interests authorization-item">
          <div class="title" style="height: 424px">权益保障</div>
          <ul>
            <li v-for="vo in info.rightsAndInterests.list" :key=" 'right' + vo.name ">
              <div class="name">{{ vo.name }}</div>
              <div class="desc">{{ vo.desc }}</div>
            </li>
          </ul>
        </div>
        <!-- 线上用途 -->
        <div class="online-use authorization-item">
          <div class="title" style="height: 509px">
            线上用途 <br>
            (全用途无限制)
          </div>
          <ul>
            <li v-for="vo in info.onlineUse.list" :key=" 'online-use' + vo.name ">
              <div class="name">{{ vo.name }}</div>
              <div class="desc">{{ vo.desc }}</div>
            </li>
          </ul>
        </div>
        <!-- 线下用途 -->
        <div class="offline-use authorization-item">
          <div class="title" style="height: 420px; border-radius: 0 0 0 20px">
            线下用途 <br>
            (全用途无限制)
          </div>
          <ul>
            <li v-for="vo in info.offlineUse.list" :key=" 'offline-use' + vo.name ">
              <div class="name">{{ vo.name }}</div>
              <div class="desc">{{ vo.desc }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="member-package-item">
        <div class="package-business package-item">
          <div class="title">
            <div class="icon-prefs">
              <i class="icon_prefs"/>
              <div class="icon-prefs-txt">商用授权首选</div>
            </div>
            <div class="name">{{ BUSINESS_VIP_INFO.NAME }}</div>
            <div class="price __price-wrap">
              <span class="text-dollar">￥</span>
              <span class="text-price">{{ BUSINESS_VIP_INFO.PRICE }}</span>
              <span class="text-year">/ 年</span>
            </div>
            <div class="buy-btn" @click="buy(BUSINESS_VIP_INFO)">立即购买</div>
          </div>
          <ul>
            <li v-for="(vo,idx) in 16" :key="'package1'+idx">
              <i class="iconfont icon-gou"/>
            </li>
          </ul>
        </div>
        <div class="package-person package-item">
          <div class="title">
            <div class="name">{{ PERSON_VIP_INFO.NAME }}</div>
            <div class="price __price-wrap">
              <span class="text-dollar">￥</span>
              <span class="text-price">{{ PERSON_VIP_INFO.PRICE }}</span>
              <span class="text-year">/ 年</span>
            </div>
            <div
              class="buy-btn"
              @click="buy(PERSON_VIP_INFO)">立即购买</div>
          </div>
          <ul>
            <li
              v-for="(vo,idx) in [0,0,1,1,1,0,0,0,0,1,0,0,0,0,0,0]"
              :key="'package1'+idx">
              <i
                class="iconfont"
                :class="[ vo === 0 ? 'icon-cha2': 'icon-gou' ]"/>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {info} from "./common/module";
import {
  BUSINESS_VIP_INFO,PERSON_VIP_INFO
} from "@/constant/VIP";

export default {
  name: "MemberPackage",
  data(){
    return{
      info,
      BUSINESS_VIP_INFO,PERSON_VIP_INFO
    }
  },
  methods:{
    buy(vipInfo){
      this.$emit('buy',vipInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
.header-bg {
  width: 100%;
  height: 474px;
  background: linear-gradient(225deg, #D093FF 0%, #6969FF 100%, #6969FF 100%);
  box-shadow: 0px 0px 0px 4px rgba(251, 247, 255, 0.2);

  .inner_center {

    width: 1200px !important;

    h2 {
      font-size: 48px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 64px;
      letter-spacing: 2px;
      padding: 72px 0 16px;
      text-align: center;
    }

    .subhead {
      font-size: 16px;
      color: #FFFFFF;
      line-height: 24px;
      letter-spacing: 1px;
      text-align: center;
    }

    .icon_vip-txt {
      @include BgImage(605px, 141px, 'member/icon_vip-txt.png');
      margin: 72px 0 0 56px;
    }
  }

}
.members-package {
  display: flex;
  border-radius: 20px;
  border: 1px solid #ECEFF6;
  //overflow: hidden;
  box-shadow: 0px 0px 25px 0px rgba(0, 0, 26, 0.06);
  margin: -114px auto 80px;
  height: 1472px;
  width: 1200px;
  background-color: #fff;
  box-sizing: border-box;
  position: relative;

  .authorization-scoped-wrap {
    width: 678px;

    /* 抽离公共代码 */
    .authorization-item {
      display: flex;
      border: 1px solid #ECEFF6;
      border-left: 0;
      box-sizing: border-box;
      border-top: 0;

      .title {
        width: 170px;
        border-right: 1px solid #ECEFF6;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-weight: bold;
        color: rgba(66, 72, 102, 0.85);
        text-align: center;

      }

      ul {
        flex: 1;

        li {
          //height: 84px;
          padding: 19px 28px;
          box-sizing: border-box;
          border-bottom: 1px solid #ECEFF6;

          &:last-child {
            border-bottom: 0;
          }

          .name {
            font-size: 16px;
            font-weight: bold;
            color: #424866;
            line-height: 21px;
            margin-bottom: 6px;
          }

          .desc {
            font-size: 14px;
            color: #424866;
            line-height: 19px;
          }
        }
      }

      &:last-child {
        border-bottom: 0;
      }
    }

    .authorization-scoped {
      height: 114px;
      line-height: 114px;
      text-align: center;
      font-size: 22px;
      font-weight: bold;
      color: #424866;
      border-bottom: 1px solid #ECEFF6;
      border-right: 1px solid #ECEFF6;
    }
  }

  .member-package-item {
    display: flex;
    position: relative;
    top: -113px;
    z-index: 10;
    background-color: #fff;
    border-radius: 20px 20px 0px 0px;
    //overflow: hidden;
    .package-item {
      width: 261px;

      .title {
        height: 227px;
        border-bottom: 1px solid #ECEFF6;
        border-right: 1px solid #ECEFF6;
        position: relative;

        @include LayoutFlex(2);

        .icon-prefs {
          @include Position(1, 5, 0, 0);
          width: 124px;
          height: 28px;
          background: linear-gradient(90deg, #FFD16C 0%, #FFAD63 100%);
          border-radius: 20px 0px 8px 0px;
          color: #FFFFFF;
          line-height: 28px;
          display: flex;
          align-items: center;
          font-size: 0;

          .icon_prefs {
            @include BgImage(15px, 15px, 'member/icon_prefs.png');
            margin: 0 4px 0 15px;

          }

          .icon-prefs-txt {
            font-size: 13px;
          }
        }

        .name {
          font-size: 22px;
          font-weight: bold;
          color: #0A2540;
        }

        .__price-wrap {
          font-size: 0;
          margin: 4px 0 14px 0;
          color: #596088;

          .text-dollar {
            font-size: 18px;
            font-weight: bold;
            line-height: 24px;
            color: $color-primary;

          }

          .text-price {
            font-size: 48px;
            font-weight: bold;
            line-height: 64px;
            //letter-spacing: 1px;
            color: $color-primary;
            margin: 0 4px;
          }

          .text-year {
            font-size: 18px;
            line-height: 24px;
          }
        }

        .buy-btn {
          width: 180px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          border-radius: 28px;
          font-size: 16px;
          cursor: pointer;
          transition: all 0.3s ease-in;
        }

      }

      ul {
        li {
          height: 85px;
          box-sizing: border-box;
          border-bottom: 1px solid #ECEFF6;
          @include LayoutFlex(1);

          .iconfont {
            font-size: 24px;
          }

          .icon-gou {
            color: #35D0BA;
          }

          .icon-cha2 {
            color: #A4A9BE;
          }

          &:last-child {
            border-bottom: 0;
          }
        }
      }

      &:first-child {
        ul {
          li {
            border-right: 1px solid #ECEFF6;
          }
        }
      }

      &:last-child {
        .title {
          border-right: 0;
          width: 261px;
          //background-color: #FFFFFF;
          position: relative;

          &:after {
            content: '';
            width: 30px;
            @include Position(1, 2, -1px, 0);
            bottom: 0;
            background-color: #FFFFFF;
            border-radius: 20px 20px 0px 0px;
          }
        }
      }

    }

    .package-business {
      .title {
        .buy-btn {
          background: #6969FF;
          color: #FFFFFF;
          @include ElementHover('', #5E5EE8);
        }
      }
    }

    .package-person {
      .title {
        .buy-btn {
          color: #6969FF;
          border: 1px solid #6969FF;
          @include ElementHover(#fff, #6969FF);
        }
      }
    }
  }
}
</style>

<!--
  会员套餐
-->

